import { useMemo, useState } from "react";
import { CustomerPortalRequestMessageAttachment } from "../../../api/models/unified";
import { isImage } from "../../../helpers/attachmentsHelepr";
import ImageViewer, { ImageViewerItem } from "../ImageViewer";
import RequestAttachmentItem from "./RequestAttachmentItem";
import Button from "../../button/Button";
import { useCustomTranslation } from "../../../helpers/translateHelpers";

interface RequestAttachmentsProps {
  attachments: CustomerPortalRequestMessageAttachment[];
}

const RequestAttachments = ({ attachments }: RequestAttachmentsProps) => {
  const { tInput } = useCustomTranslation();

  const [attachmentToPreview, setAttachmentToPreview] = useState<
    ImageViewerItem | undefined
  >();

  const [showAll, setShowAll] = useState(false);

  const images = useMemo(
    () => attachments.filter((x) => isImage(x)),
    [attachments],
  );

  const otherAttachments = useMemo(
    () => attachments.filter((x) => !isImage(x)),
    [attachments],
  );

  const showAllButton =
    (images.length > 5 || otherAttachments.length > 5) && !showAll;

  return (
    <>
      <div className="flex flex-col gap-4">
        {images.length > 0 && (
          <div className="flex flex-row flex-wrap items-center">
            {(showAll ? images : images.slice(0, 5)).map((attachment) => (
              <RequestAttachmentItem
                key={attachment.id}
                attachment={attachment}
                handleOpenPreview={() => setAttachmentToPreview(attachment)}
              />
            ))}
          </div>
        )}
        {otherAttachments.length > 0 && (
          <div className="flex flex-col gap-2">
            {(showAll ? otherAttachments : otherAttachments.slice(0, 5)).map(
              (attachment) => (
                <RequestAttachmentItem
                  key={attachment.id}
                  attachment={attachment}
                  handleOpenPreview={() => setAttachmentToPreview(attachment)}
                />
              ),
            )}
          </div>
        )}
        {showAllButton && (
          <Button
            className="self-start"
            label={tInput("attachments_show_more")}
            size="small"
            onClick={() => setShowAll(true)}
          />
        )}
      </div>
      {attachmentToPreview && (
        <ImageViewer
          attachments={images}
          onClose={() => setAttachmentToPreview(undefined)}
          startIndex={images.findIndex((x) => x.id === attachmentToPreview.id)}
        />
      )}
    </>
  );
};

export default RequestAttachments;
